import { HashRouter as Router, Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import Central_Ajuda from './pages/opc_gerais/central_ajuda/Central_Ajuda';
import Termos from './pages/opc_gerais/termos/Termos';
import Crescer from './pages/opc_gerais/crescer/Crescer';
import Sobre from './pages/opc_gerais/sobre/Sobre';


import { useEffect, useRef, useState } from 'react';
import { ShowPopUpConfirmationV2 } from './components/PopUp';
import Estabelecimentos from './pages/opc_gerais/estabelecimentos';
import { SiteTemporario } from './pages/siteTemporario';
import { Controls } from './Controls';
import { LINKS_APOIO_E_PATROCINEO, LINKS_CENTRAL_DE_AJUDA, LINKS_PARA_CLIENTES, LINKS_PARA_MERCADOS, LINKS_TERMOS } from './Links';
import { PROXY_POST_MESSAGE_SITE } from './_proxy';

function RoutesTracker() {
  const location = useLocation(); // Hook que dá a URL atual
  const lastPathRef = useRef(null); // guarda a última rota processada

  useEffect(() => {
    //if (utils_iam_iframe) return;//somente janela principal
    if (lastPathRef.current === location.pathname) return //somente diferenças entre links
    lastPathRef.current = location.pathname;
    window.parent.postMessage(
      { type: PROXY_POST_MESSAGE_SITE, pathname: location.pathname },
      "*"
    );
  }, [location.pathname]);

  return null
}
export function useApp() {
  const navigate = useNavigate();

  function reloadApp() {
    navigate('/#/');
  }

  return { reloadApp };
}
function App() {

  /*
* REGION POP UP
*/
  const [statePopUpOpen, setStatePopUpOpen] = useState(false);
  const [statePopUpMsg, setstatePopUpMsg] = useState('');
  const [statePopUpCallback, setstatePopUpCallback] = useState(null);
  const [statePopUpIgnore_confirmation, setstatePopUpIgnore_confirmation] = useState(false);

  function ShowAlertView(msg, callback = () => { }, ignore_confirmation = true) {
    setStatePopUpOpen(true)
    setstatePopUpMsg(msg);
    if (callback !== null) {
      setstatePopUpCallback(() => {
        return () => {
          callback();
        }
      });
      setstatePopUpIgnore_confirmation(ignore_confirmation);
    }
  }
  /*
  * END
  */



  return (
    <Router>
      <RoutesTracker />

      {statePopUpOpen &&
        <ShowPopUpConfirmationV2
          msg={statePopUpMsg}
          closePopup={() => setStatePopUpOpen(false)}
          callback={statePopUpCallback}
          ignore_confirmation={statePopUpIgnore_confirmation}
        />
      }

      <Routes>
        <Route path="/" element={<SiteTemporario />} />

        <Route path={LINKS_CENTRAL_DE_AJUDA} element={<Central_Ajuda Titulo='Central de Atendimento' NavDestacada={true} />} />
        <Route path={LINKS_TERMOS} element={<Termos Titulo='Termos de uso' />} />

        <Route path={LINKS_APOIO_E_PATROCINEO} element={<Crescer Titulo='Apoie o TooMe' />} />
        <Route path={LINKS_PARA_CLIENTES} element={<Sobre Titulo='Sobre nós' NavDestacada={false} ShowAlertView={ShowAlertView} />} />

        <Route path={LINKS_PARA_MERCADOS} element={<Estabelecimentos Titulo='Para Estabelecimentos' />} />
        <Route path="*" element={<Controls />} />
      </Routes>
    </Router>
  );
}

export default App;
